import { type ReactElement } from "react";
import Typography from "@mui/material/Typography";
import { TextField } from "@/components/TextField";
import { Button, ButtonVariantOption } from "@/components/Button";
import { Box, type InputBaseComponentProps } from "@mui/material";
import { SizingWrapperStyle } from "@/components/Wrapper";
import {
  NYHalfWidthNumberToFillWidthNumber,
  convertCirclesToZero,
} from "@/utils/utils";

interface Props {
  label: string;
  handleApiRequest: () => Promise<void>;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  disabled: boolean;
  inputProps?: InputBaseComponentProps;
}

export const SearchBox = ({
  label,
  handleApiRequest,
  searchTerm,
  setSearchTerm,
  disabled,
  inputProps,
}: Props): ReactElement<Props> => {
  return (
    <div>
      <Typography>{label}</Typography>
      <Box>
        <Box sx={{ my: 1 }}>
          <TextField
            id="chiban"
            label={label}
            onChange={setSearchTerm}
            onBlur={(event) => {
              // onChange に変換処理を入れると、入力中の変換が自動的に確定されてしまうため、
              // onBlur に変換処理を入れる
              const result = NYHalfWidthNumberToFillWidthNumber(
                convertCirclesToZero(event.target.value)
              );
              setSearchTerm(result);
            }}
            size={SizingWrapperStyle.INHERIT}
            value={searchTerm}
            autoFocus={false}
            disabled={disabled}
            inputProps={inputProps}
          />
        </Box>
        <Box sx={{ my: 1 }}>
          <Button
            label={"検索"}
            onClick={() => {
              void handleApiRequest();
            }}
            size={SizingWrapperStyle.INHERIT}
            variant={ButtonVariantOption.Contained}
            disabled={disabled}
          />
        </Box>
      </Box>
    </div>
  );
};
